<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg5>
            <v-card class="pf-box-shadow-2 border-radius-10 pt-4 px-3 pb-3">
              <v-card-text class="pb-0">
                <div class="layout column align-center pb-4">
                  <img src="/static/login_logo.png" alt="Parent Finder">
                </div>
                <v-layout class="pf-error-alert" v-if="longError">
                  <v-flex class="flex-row">
                    <v-icon size="17" class="red--text mr-2">warning</v-icon>
                    <span class="error-text">{{ longError }}</span>
                  </v-flex>
                </v-layout>
                <v-form ref="loginForm">
                  <v-text-field 
                    name="username" ref="username"
                    height="40"
                    label="Username" type="text" :disabled="form.username.disabled" v-model.trim="form.username.value"
                    browser-autocomplete="new-username"
                    v-on:keyup.enter="login"
                    :rules="[v => !!v || '']"
                  ></v-text-field>
                  <!-- :append-icon="showPassword ? 'visibility' : 'visibility_off'" -->
                  <!-- @click:append="showPassword = !showPassword" -->
                  <v-text-field 
                    height="40"
                    :type="showPassword ? 'text' : 'password'"
                    browser-autocomplete="new-password"
                    name="password" ref="password" 
                    label="Password" id="password"
                    :disabled="form.password.disabled" 
                    v-model.trim="form.password.value"
                    v-on:keyup.enter="login"
                    :rules="[v => !!v || '']"
                  >
                    <template v-slot:append>
                      <span class="input-show-hide" icon @click="showPassword = !showPassword">
                        {{ showPassword ? 'Hide' : 'Show' }}
                      </span>
                    </template>
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-flex class="flex-row mx-3" v-if="error">
                <v-icon size="17" class="red--text mr-2">warning</v-icon>
                <span class="red--text font-weight-bold">{{ error }}</span>
              </v-flex>
              <v-card-actions class="mt-3">
                <v-spacer></v-spacer>
                <v-btn class="pf-btn pf-bg-green login-btn border-radius-10" @click="login" ref="sigInBtn" :loading="loading">Login</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
              <v-layout class="pa-3 flex-column">
                <v-flex class="flex-center">
                  <!-- <span>New to Parentfinder? <a class="pf-auth-link" :href="`#/join`">Join here</a></span> -->
                  <span>New to Parentfinder? <a class="pf-auth-link" :href="`${config.host}pricing/`">Join here</a></span>
                </v-flex>
                <v-flex class="flex-space-around mt-3">
                  <router-link class="pf-text-dark grey py-2 px-3 border-radius-5 lighten-4" to="/forgotUsername">Forgot Username</router-link>
                  <router-link class="pf-text-dark grey py-2 px-3 border-radius-5 lighten-4" to="/forgotPassword">Forgot Password</router-link>
                </v-flex>
                <v-flex class="mt-3 line"></v-flex>
                <v-flex class="flex-space-between mt-4 mx-3">
                  <a class="pf-text-dark font-weight-bold" :href="config.host">Home</a>
                  <a target="_blank" class="pf-text-dark font-weight-bold" :href="config.helpForm">Need Help?</a>
                </v-flex>
                <!-- <v-layout class="flex-center">
                  <v-flex class="line"></v-flex>
                  <v-flex class="flex-no-grow mx-3">OR</v-flex>
                  <v-flex class="line"></v-flex>
                </v-layout> -->
                <!-- Social media icons -->
                <!-- <v-layout class="flex-center mt-3">
                  <v-btn icon depressed class="login-with-btn" color="bg-facebook">
                    <v-icon size="20" class="white--text">fa fa-facebook</v-icon>
                  </v-btn>
                  <v-btn icon depressed class="login-with-btn" color="bg-google">
                    <v-icon size="20" class="white--text">fa fa-google-plus</v-icon>
                  </v-btn>
                  <v-btn icon depressed class="login-with-btn" color="bg-instagram">
                    <v-icon size="20" class="white--text">fab fa-instagram</v-icon>
                  </v-btn>
                  <v-btn icon depressed class="login-with-btn" color="bg-apple">
                    <v-icon size="20" class="white--text">fab fa-apple</v-icon>
                  </v-btn>
                </v-layout> -->
                <span class="mt-3 text-center pf-font-12">By logging into Parentfinder, you are agreeing to Parentfinder's <a class="pf-auth-link" target="_blank" :href="`${config.host}privacy-policy`">Terms and Conditions</a></span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import Login from './Login.vm.js';
export default Login;
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
  .line {
    flex-grow: 1;
    border-top: 1px solid #019d8c54; /* Adjust color and thickness as needed */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue